import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map, shareReplay, tap} from 'rxjs/operators';
import {UserService} from './user.service';
import {AuthService} from '../auth/auth.service';

/**
 * resolves the id of the logged-in user, which is part of every folder, notification and settings uri.
 * The id is cached per token, so logging in as another user fetches it again.
 */
@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {

  private token: string;
  private userId: number;
  private request$: Observable<number>;

  constructor(private userService: UserService, private authService: AuthService) {
  }

  getUserId(): Observable<number> {
    const token = this.authService.getToken();
    if (token !== this.token || !this.request$) {
      this.token = token;
      this.userId = undefined;
      this.request$ = this.userService.getCurrentUser().pipe(
        map(user => user.id),
        tap(id => this.userId = id),
        shareReplay(1)
      );
    }
    return this.userId !== undefined ? of(this.userId) : this.request$;
  }

  /**
   * whether the logged-in user may use Sammelmappen (paid users and admins)
   */
  canUseFolders(): boolean {
    const role = this.authService.getUserRole();
    return role === 'ROLE_USER_PAID' || role === 'ROLE_ADMIN';
  }
}
